// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__nmHh-","content":"styles_content__12yZ1","tableWrap":"styles_tableWrap__1uXth"};